// extracted by mini-css-extract-plugin
module.exports = {"container":"CampaignDescription_container__2K4zl","description":"CampaignDescription_description__2nJ1k"};